'use client';
var IDENT = "CheckboxGroup";
var defaultProps = {
    size: "sm1"
};

export { IDENT, defaultProps };
